// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__1q3M+","info":"Notes_info__6X7a-","cards":"Notes_cards__BXcf5"};